export default "__VITE_ASSET__bZDU2gBJ__"